
import { defineComponent } from '@vue/runtime-core';
import { DummyState } from '@/store/modules/dummy';
import { createNamespacedHelpers } from 'vuex';
import Armor from './Armor/Armor.vue';

const { mapMutations, mapState, mapGetters } = createNamespacedHelpers('dummy');

export default defineComponent({
  components: { Armor },
  name: 'Dummy',
  computed: {
    ...mapState<DummyState>({
      person: (state: DummyState) => state.person,
    }),
    ...mapGetters(['hp', 'hasArmor', 'characteristics', 'armorMaterials']),
  },
  methods: {
    ...mapMutations(['setArmor', 'setArmorMaterial', 'wearArmor', 'takeOffArmor', 'resetHp']),
    onClick() {
      if (this.hasArmor) {
        this.takeOffArmor();
        return;
      }
      this.wearArmor();
    },
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
    };
  },
});
